/**
 * Method for checking if a string is ASCII art.
 * @param body - Message body to check.
 * @returns boolean - Whether the string is ASCII art or not.
 *
 * A string is considered ASCII art if it has at least three lines,
 * each line is between 5 and 100 characters long, and the lengths of
 * the lines vary by at most 25 characters.
 *
 * Additionally, the string must contain only printable ASCII characters
 * (i.e. characters between U+0020 and U+007E, inclusive, as well as
 * newline and carriage return characters).
 */
export const isAsciiArt = (body: string): boolean => {
  const lines = body.split('\n')
  if (lines.length < 3) {
    return false // Not enough lines to be ASCII art
  }

  const lineLengths = lines.map((line) => line.length)
  const minLength = Math.min(...lineLengths)
  const maxLength = Math.max(...lineLengths)

  if (maxLength > 100 || minLength < 5) {
    return false // Lines are too long or short
  }

  const lengthVariance = maxLength - minLength

  if (lengthVariance > 25) {
    return false // Lines are too different in length
  }

  const asciiRegex = /^[\x20-\x7E\n\r]+$/

  return asciiRegex.test(body)
}

// This regex detects strings that contain only emoji characters
export const emojiParser = (body: string): { enlargeEmojies: boolean } => {
  const regex =
    /^(\u00a9|\u00ae|[\u2000-\u200c\u200e-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff]|\u200d|\ufe0f)+$/

  return { enlargeEmojies: regex.test(body.trim()) }
}
